import { createContext } from "react";

const authContext = createContext({
  authenticated: false,
  user: {},
});

export const AuthProvider = authContext.Provider;
export const AuthConsumer = authContext.Consumer;
export const AuthContext = authContext;